// Minimal stylised SVG flags for region tiles
export const FlagUK = ({ className = "" }) => (
  <svg
    viewBox="0 0 60 30"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-label="United Kingdom flag"
  >
    <clipPath id="uk-c">
      <path d="M0 0v30h60V0z" />
    </clipPath>
    <clipPath id="uk-t">
      <path d="M30 15h30v15zv15H0zH0V0zV0h30z" />
    </clipPath>
    <g clipPath="url(#uk-c)">
      <path fill="#012169" d="M0 0v30h60V0z" />
      <path
        stroke="#fff"
        strokeWidth="6"
        d="M0 0l60 30m0-30L0 30"
      />
      <path
        clipPath="url(#uk-t)"
        stroke="#C8102E"
        strokeWidth="4"
        d="M0 0l60 30m0-30L0 30"
      />
      <path stroke="#fff" strokeWidth="10" d="M30 0v30M0 15h60" />
      <path stroke="#C8102E" strokeWidth="6" d="M30 0v30M0 15h60" />
    </g>
  </svg>
);

export const FlagAU = ({ className = "" }) => (
  <svg
    viewBox="0 0 60 30"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Australian flag"
  >
    <path fill="#012169" d="M0 0h60v30H0z" />
    {/* Union Jack canton */}
    <g transform="scale(0.5)">
      <clipPath id="au-c">
        <path d="M0 0v30h60V0z" />
      </clipPath>
      <clipPath id="au-t">
        <path d="M30 15h30v15zv15H0zH0V0zV0h30z" />
      </clipPath>
      <g clipPath="url(#au-c)">
        <path fill="#012169" d="M0 0v30h60V0z" />
        <path stroke="#fff" strokeWidth="6" d="M0 0l60 30m0-30L0 30" />
        <path
          clipPath="url(#au-t)"
          stroke="#C8102E"
          strokeWidth="4"
          d="M0 0l60 30m0-30L0 30"
        />
        <path stroke="#fff" strokeWidth="10" d="M30 0v30M0 15h60" />
        <path stroke="#C8102E" strokeWidth="6" d="M30 0v30M0 15h60" />
      </g>
    </g>
    {/* Commonwealth star */}
    <g fill="#fff">
      <polygon points="15,18 16,21 19,21 16.5,23 17.5,26 15,24 12.5,26 13.5,23 11,21 14,21" />
      {/* Southern cross simplified */}
      <circle cx="48" cy="6" r="1" />
      <circle cx="52" cy="14" r="1.2" />
      <circle cx="44" cy="14" r="1" />
      <circle cx="48" cy="22" r="1.2" />
      <circle cx="55" cy="20" r="0.8" />
    </g>
  </svg>
);

export const FlagNZ = ({ className = "" }) => (
  <svg
    viewBox="0 0 60 30"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-label="New Zealand flag"
  >
    <path fill="#012169" d="M0 0h60v30H0z" />
    {/* Union Jack canton */}
    <g transform="scale(0.5)">
      <clipPath id="nz-c">
        <path d="M0 0v30h60V0z" />
      </clipPath>
      <clipPath id="nz-t">
        <path d="M30 15h30v15zv15H0zH0V0zV0h30z" />
      </clipPath>
      <g clipPath="url(#nz-c)">
        <path fill="#012169" d="M0 0v30h60V0z" />
        <path stroke="#fff" strokeWidth="6" d="M0 0l60 30m0-30L0 30" />
        <path
          clipPath="url(#nz-t)"
          stroke="#C8102E"
          strokeWidth="4"
          d="M0 0l60 30m0-30L0 30"
        />
        <path stroke="#fff" strokeWidth="10" d="M30 0v30M0 15h60" />
        <path stroke="#C8102E" strokeWidth="6" d="M30 0v30M0 15h60" />
      </g>
    </g>
    {/* Southern Cross — 4 red stars w/ white outline */}
    <g>
      <g transform="translate(44,7)">
        <polygon points="0,-2.4 0.7,-0.7 2.4,-0.7 1,0.3 1.6,2 0,1 -1.6,2 -1,0.3 -2.4,-0.7 -0.7,-0.7" fill="#fff" />
        <polygon points="0,-1.7 0.5,-0.5 1.7,-0.5 0.7,0.2 1.1,1.4 0,0.7 -1.1,1.4 -0.7,0.2 -1.7,-0.5 -0.5,-0.5" fill="#C8102E" />
      </g>
      <g transform="translate(52,14)">
        <polygon points="0,-2.8 0.8,-0.8 2.8,-0.8 1.2,0.3 1.8,2.3 0,1.2 -1.8,2.3 -1.2,0.3 -2.8,-0.8 -0.8,-0.8" fill="#fff" />
        <polygon points="0,-2 0.6,-0.6 2,-0.6 0.8,0.2 1.3,1.6 0,0.8 -1.3,1.6 -0.8,0.2 -2,-0.6 -0.6,-0.6" fill="#C8102E" />
      </g>
      <g transform="translate(42,18)">
        <polygon points="0,-2.4 0.7,-0.7 2.4,-0.7 1,0.3 1.6,2 0,1 -1.6,2 -1,0.3 -2.4,-0.7 -0.7,-0.7" fill="#fff" />
        <polygon points="0,-1.7 0.5,-0.5 1.7,-0.5 0.7,0.2 1.1,1.4 0,0.7 -1.1,1.4 -0.7,0.2 -1.7,-0.5 -0.5,-0.5" fill="#C8102E" />
      </g>
      <g transform="translate(50,24)">
        <polygon points="0,-2.4 0.7,-0.7 2.4,-0.7 1,0.3 1.6,2 0,1 -1.6,2 -1,0.3 -2.4,-0.7 -0.7,-0.7" fill="#fff" />
        <polygon points="0,-1.7 0.5,-0.5 1.7,-0.5 0.7,0.2 1.1,1.4 0,0.7 -1.1,1.4 -0.7,0.2 -1.7,-0.5 -0.5,-0.5" fill="#C8102E" />
      </g>
    </g>
  </svg>
);
